import { registerBpmnJSPlugin } from "camunda-modeler-plugin-helpers";
import DocumentationExtension from "./extension";

registerBpmnJSPlugin(DocumentationExtension);
